import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css';
import ElementUI,{Message,MessageBox}  from 'element-ui';
import store from './store';
import {createRouter} from './router'
import {createTrtcCalling} from './trtc-calling';
import TRTCCalling from 'trtc-calling-js';
import App from './App.vue'
  import axios from 'axios'

Vue.use(ElementUI);
import VueCropper from 'vue-cropper'
Vue.use(VueCropper)
 
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;

Vue.prototype.$trtcCalling = createTrtcCalling();
Vue.prototype.TrtcCalling = TRTCCalling;

Vue.config.productionTip = false
Vue.prototype.$axios = axios;
new Vue({
  render: h => h(App),
  store,
  router: createRouter()
}).$mount('#app')
